// app/studente/classi.js

(function () {
	'use strict';
	var controllerId = 'tAttach';
	angular.module('app').controller(controllerId, ['common', '$scope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', tAttach]);

	function tAttach(common, $scope, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');

		var vm = this;
		vm.title = 'Tipologia Allegati';
		vm.view = 'list';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection(vm.title);

		vm.objName = "attach"; //Utilizzato per pannello authorization
		//vm.authorization = {};
		vm.showObjPanel = false;
		vm.record = {};
		vm.records = [];
		vm.countRecords = 0;
		vm.index = 0;
		vm.custom = false;
		

		vm.addDisabled = false;
		vm.exportDisabled = false;
		vm.pageSize = 30;
		vm.page = 1;
		vm.loading = false;

		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['TSource', 'Name'];
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
		    vm.ordine = item;
		    cerca();
        };       

		vm.getRecord = getRecord;
		vm.getListRuoli = getListRuoli;
		vm.deleteRuolo = deleteRuolo;


		//Filtro
		vm.filter = {};
		vm.fTSourceId = 0;
		vm.fTestuale = '';
		vm.fRoleId = 0;
		vm.filter.tSourceId = vm.fTSourceId;
		vm.filter.testuale = vm.fTestuale;
		vm.filter.roleId = vm.fRoleId;

		//Elenchi per filtri e finestra modale di Create
		vm.tSource = [];
		vm.ruoli = [];

	    //Elenchi Dettaglio
		vm.list.ruoli = [];
        vm.lstRoles = [];
        vm.list.tipologie = [];

		//Metodi su interfaccia
		vm.cerca = cerca;
		vm.loadMore = getAllByFilter;
		vm.loadAll = getAll;
		

		vm.goNext = goNext;
		vm.goPrev = goPrev;


		vm.get = getRecord;
		vm.add = addModal;
		vm.update = updateItem;
		vm.delete = deleteItem;
		vm.deletedChildren = 0;
        vm.addRole = addModalRole;
        vm.addTipologia = addModalTipologia;

        vm.getListTipologie = getListTipologie;
        vm.deleteTipologia = deleteTipologia;

        vm.change_iImporto1 = change_CarattVariable;
        vm.change_iValore1 = change_CarattVariable;
        vm.change_iBit1 = change_CarattVariable;
        vm.change_iTesto1 = change_CarattVariable;
        vm.change_CarattVariable = change_CarattVariable;

		// ---- ACTIVATE -------
		activate();

		function activate() {
		    var promises = [getTSource(), getRuoli(), getRoles(), /*getAuthorization()*/];
			common.activateController(promises, controllerId)
							.then(function () {

								if ($routeParams.TAttachId != null) {
									setView('detail');
									getRecord($routeParams.TAttachId, 0);
								}

							});
		}


		//****************************************************
		// METODI 
		//****************************************************
		function setView(view) {
			return vm.view = view;
		}


		function cerca() {
			vm.records = [];
			vm.countRecords = 0;
			vm.page = 1;
			vm.filter.tSourceId = vm.fTSourceId == null ? 0 : vm.fTSourceId;
			vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
			vm.filter.roleId = vm.fRoleId == null ? 0 : vm.fRoleId;


			vm.loading = false;
			countByFilter();
			return getAllByFilter();
		}

		function countByFilter() {
		    return datacontext.tAttach_countAll('', vm.filter.tSourceId, vm.filter.testuale, vm.filter.roleId)
						.then(function (data) {
							if (data) {
								vm.countRecords = data;
							}
						});
		}

		function getAllByFilter() {
			if (vm.loading === true) return;

			if (vm.countRecords == 0) countByFilter();
			else if (vm.countRecords <= vm.records.length) return;

			vm.loading = true;
			return datacontext.tAttach_getAll(vm.pageSize, vm.page, '', vm.filter.tSourceId, vm.filter.testuale, vm.filter.roleId, vm.ordine)
					.then(function (data) {
						if (data.constructor === Array) {
							vm.page++;
							data.forEach(function (item) {
								vm.records.push(item);
							});
						}
						vm.loading = false;
					});
		}

		function getAll() {
			if (vm.records.length < vm.countRecords) {
				getAllByFilter().then(function () { getAll(); });
			}
		}
/*
		function getAuthorization() {
            vm.addDisabled = true;
            
			return datacontext.authorization_get(vm.objName)
					.then(function (data) {
						vm.authorization = data;
						vm.addDisabled = !vm.authorization.bInsert;
					});
		}
        */
		function getRecord(id, index) {
		    return datacontext.tAttach_get(id).then(function (data) {
				vm.index = index;
				vm.record = data;

		        //Azzera liste
                vm.list.ruoli = [];
                vm.list.tipologie = [];

				setView('detail');
			});
		}

		function goNext() {
			if (vm.index + 1 >= vm.countRecords) return;
			if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
				getByFilter();
			}
			if (!vm.records) return;

			vm.index++;
			return getRecord(vm.records[vm.index].Id, vm.index);
		}

		function goPrev() {
			if (vm.index == 0) return;
			if (!vm.records) return;

			vm.index--;

			return getRecord(vm.records[vm.index].Id, vm.index);
		}


		function addRecord(id) {
		    return datacontext.tAttach_get(id).then(function (data) {
				vm.records.push(data);
				vm.countRecords++;
			});
		}

		function updateItem() {
		    return datacontext.tAttach_update(vm.record).then(function (data) {
				if (data == "400") return logError('Errore cancellazione dati [' + data + ']');

				vm.records[vm.index] = data;
				logSuccess('Record Salvato ');
			});
		}

		function deleteItem(item) {
			var msg = 'Tipologia Allegato: ' + item.Name + '?';
			bDialog.deleteDialog(msg).then(function () {
			    if (item.Id > 0) {
			        deleteChildren(0, item.Id);
			    }
			    return datacontext.tAttach_delete(item.Id).then(function (data) {
					if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

					var index = vm.records.indexOf(item)
					vm.records.splice(index, 1);
					vm.countRecords--;
				});
			});
		}

		function deleteChildren(roleId, tAttachId) {
		    return datacontext.deleteChildrenOfRoleIdOrUserId(roleId, tAttachId).then(function (data) {
		        return vm.deletedChildren = data;
		    });
		}

		//List Methods
		function getListRuoli(tAttachId, roleId) {
		    return datacontext.tAttachVisibility_getAll(tAttachId, roleId).then(function (data) {
		        //console.info('getListRuoli', data);
		        return vm.list.ruoli = data;
		    });
		}

		function deleteRuolo(item) {
		    var msg = ' Ruolo ' + item.Role_Etichetta + ' per la tipologia ' + vm.record.Name;
		    bDialog.deleteDialog(msg).then(function () {
		        return datacontext.tAttachVisibility_delete(item.Id).then(function (data) {
		            if (data == "404") return logError('Errore ruolo non rimosso');

		            var index = vm.list.ruoli.indexOf(item)
		            vm.list.ruoli.splice(index, 1);
		        });
		    });
		}

		//Elenchi Parametri
		function getTSource() {
			return datacontext.tSource_getAllList().then(function (data) {
			    return vm.tSource = data;
			});
		}

		function getRuoli() {
		    return datacontext.role_getAll().then(function (data) {
		        return vm.ruoli = data;
		    });
		}

		function getRoles() {
		    return datacontext.role_getAllList().then(function (data) {
		        return vm.lstRoles = data;
		    });
        }

        //TIPOLOGIA
        function getListTipologie(tAttachId, title, extension) {
            return datacontext.tAttachFileType_getAll(tAttachId, title, extension).then(function (data) {
                return vm.list.tipologie = data;
            });
        }

        function deleteTipologia(item) {
            var msg = ' l\'estensione \'' + item.Title + '\' per la tipologia \'' + vm.record.Name + '\'';
            bDialog.deleteDialog(msg).then(function () {
                //console.dir(item);
                //console.info('deleteTipologia', vm.record.Id, item.Title, item.Extension);
                return datacontext.tAttachFileType_delete(item.Id).then(function (data) {
                    if (data == "404") return logError('Errore tipologia non rimossa');

                    var index = vm.list.tipologie.indexOf(item)
                    vm.list.tipologie.splice(index, 1);
                });
            });
        }

        function getTipologie() {//mix tra getRoles e getRuoli
            return datacontext.tAttachFileType_getAll('').then(function (data) {
                return vm.tipologie = data;

            });
        }

        function change_CarattVariable(value, variable) {
            if (value == 0) {
                if (variable == 'labelImporto1')
                    vm.record.labelImporto1 = '';
                else if (variable == 'labelValore1')
                    vm.record.labelValore1 = '';
                else if (variable == 'labelBit1')
                    vm.record.labelBit1 = '';
                else if (variable == 'labelTesto1')
                    vm.record.labelTesto1 = '';
            }
        }
        



		//****************************************************
		// OPEN MODAL DIALOG
		//****************************************************
		function addModal() {
			var modalInstance = modal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/tAttach/modal/tAttachAdd.html?version=30',
				controller: 'tAttachAdd',
				resolve: {
					tSource: function () {
						return vm.tSource;
					},
					tSourceId: function () {
						return null;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
				if (!returnItem) return logError('errore di creazione! ');

				logSuccess('Dato salvato con successo! ');
				addRecord(returnItem.Id);
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
		};

	    //Ruolo
		function addModalRole(item) {
		    var record = { Id: vm.record.Id, Name: vm.record.Name + " - " + vm.record.TSource };

			var modalInstance = modal.open({
				backdrop: 'static',
				keyboard: false,
		        templateUrl: '/app/tAttach/modal/tAttachRoleAdd.html?version=30',
		        controller: 'tAttachRoleAdd',
		        resolve: {
		            tAttach: function () {
		                return [record];
		            },
		            tAttachId: function () {
		                return vm.record.Id;
		            },
		            ruoli: function () {
		                return vm.ruoli;
		            },
		            ruoloId: function () {
		                return null;
                    },
                    tSourceId: function () {
                        return vm.record.TSourceId;
                    },
                    tAttachRole: function () {
                        return item;
                    }
		        }
		    });

		    modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Attenzione: tentativo di duplicazione! ');
                if (returnItem == "404") return logError('Errore di creazione! ');
                if ($.isNumeric(returnItem)) return logError('Errore generico! ');

		        logSuccess('record creato con successo! ');
		        getListRuoli(vm.record.Id, 0);
		    }, function () {
		        //log('Modal dismissed at: ' + new Date());
		    });
        };

        //Tipologia
        function addModalTipologia() {
            var record = { Id: vm.record.Id, Name: vm.record.Name + " - " + vm.record.TSource };

			var modalInstance = modal.open({
				backdrop: 'static',
				keyboard: false,
                templateUrl: '/app/tAttach/modal/tAttachTipologiaAdd.html?version=30',
                controller: 'tAttachTipologiaAdd',
                resolve: {
                    tAttach: function () {
                        return [record];
                    },
                    tAttachId: function () {
                        return vm.record.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('errore di creazione! ');
                if ($.isNumeric(returnItem)) return logError('errore di creazione! ');

                logSuccess('record creato con successo! ');
                getListTipologie(vm.record.Id, '', '');
                //console.info('getListTipologie', getListTipologie);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

	}
})();
